import styled from 'styled-components';

export const FocusHeaderWrapper = styled.div`
  box-sizing: border-box;
  min-height: 76px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  box-shadow: 0 1px 2px 0 rgba(17, 17, 17, 0.3);
  width: 100%;
`;

export const FocusHeaderSpacer = styled.div`
  height: ${({ theme }) => theme.spacing.xxsmall.default};
`;

export const FocusHeaderSection = styled.div`
  display: flex;
  align-items: center;
`;

export const HeadingArea = styled.div`
  margin: 0 0 0 25px;
  display: inline-block;
`;

export const PageTitle = styled.h2`
  font-size: 18px;
  font-weight: normal;
  color: #0b0b0b;
  margin: 0;
`;
